import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
}

const ModalAlertTwoMinutes = ({ isOpen, onConfirm }: Props) => {
  return (
    <div className="flex justify-center mb-xxlg">
      <CcModal visible={isOpen} hideCloseButton>
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            Te quedan 2 minutos para enviar tu examen
          </h2>
          <p className="text-center text-color-02">
            Si no terminas a tiempo, se procesarán los resultados hasta donde
            avanzaste.
          </p>
        </div>
        <div className="flex justify-center gap-lg modal-buttons">
          <Button
            text="Entiendo"
            className="w-full"
            color="primary"
            onClick={onConfirm}
            data-testid="btn-confirm"
          />
        </div>
      </CcModal>
    </div>
  );
};

export default ModalAlertTwoMinutes;
